/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './consumable-order.reducer';

export const ConsumableOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const consumableOrderEntity = useAppSelector(state => state.consumableOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consumableOrderDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.consumableOrder.detail.title">ConsumableOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.consumableOrder.id">Id</Translate>
            </span>
          </dt>
          <dd>{consumableOrderEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.consumableOrder.active">Active</Translate>
            </span>
          </dt>
          <dd>{consumableOrderEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.consumableOrder.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{consumableOrderEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.consumableOrder.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{consumableOrderEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.consumableOrder.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{consumableOrderEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.consumableOrder.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{consumableOrderEntity.cursor}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.consumableOrder.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{consumableOrderEntity.patientType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.consumableOrder.admission">Admission</Translate>
          </dt>
          <dd>{consumableOrderEntity.admission ? consumableOrderEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.consumableOrder.orderedBy">Ordered By</Translate>
          </dt>
          <dd>{consumableOrderEntity.orderedBy ? consumableOrderEntity.orderedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.consumableOrder.prescription">Prescription</Translate>
          </dt>
          <dd>{consumableOrderEntity.prescription ? consumableOrderEntity.prescription.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/consumable-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/consumable-order/${consumableOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsumableOrderDetail;
